import { ColumnDefinition } from '../types';

export const ALL_COLUMNS: ColumnDefinition[] = [
    // Default columns
    { key: 'company', label: 'Company', category: 'lokasi' },
    { key: 'estate', label: 'Estate', category: 'lokasi' },
    { key: 'wb_ticket_no', label: 'Nomor Tiket', category: 'dokumen' },
    { key: 'wb_weight', label: 'Berat Timbangan (Kg)', category: 'timbangan', isNumeric: true },
    { key: 'spb_date', label: 'Tanggal Masuk / SPB', category: 'dokumen' },
    { key: 'date_posting', label: 'Tanggal Posting', category: 'dokumen' },
    { key: 'division', label: 'Divisi', category: 'lokasi' },
    { key: 'block', label: 'Petak / Blok', category: 'lokasi' },
    { key: 'bunch_qty', label: 'Janjang', category: 'timbangan', isNumeric: true },
    { key: 'ref_bjr', label: 'BJR Acuan', category: 'timbangan', isNumeric: true },
    { key: 'ref_weight', label: 'Kg Acuan', category: 'timbangan', isNumeric: true },
    { key: 'real_weight', label: 'Real Weight', category: 'timbangan', isNumeric: true },

    // Additional selectable columns
    { key: 'spb_nbr', label: 'SPB Number', category: 'dokumen' },
    { key: 'harvest_nbr', label: 'Harvest Number', category: 'dokumen' },
    { key: 'rkh_nbr', label: 'RKH Number', category: 'dokumen' },
    { key: 'harvest_date', label: 'Harvest Date', category: 'dokumen' },
    { key: 'emp_nip', label: 'Emp NIP', category: 'dokumen' },
    { key: 'emp_name', label: 'Emp Name', category: 'dokumen' },
    { key: 'attendance_type_code', label: 'Attendance Type Code', category: 'dokumen' },
    { key: 'tph', label: 'TPH', category: 'lokasi' },
    { key: 'ha_amt', label: 'Ha Amt', category: 'lokasi', isNumeric: true },
    { key: 'total_bunch_qty', label: 'Total Bunch Quantity', category: 'timbangan', isNumeric: true },
    { key: 'total_ref_weight', label: 'Total Ref Weight', category: 'timbangan', isNumeric: true },
    { key: 'total_real_weight', label: 'Total Real Weight', category: 'timbangan', isNumeric: true },
    { key: 'real_bjr', label: 'Real BJR', category: 'timbangan', isNumeric: true },
    { key: 'real_weight_emp', label: 'Real Weight Emp', category: 'timbangan', isNumeric: true },
    { key: 'is_kutip_required', label: 'Is Kutip Required', category: 'dokumen' },
    { key: 'weightbase', label: 'Weightbase', category: 'kalkulasi', isNumeric: true },
    { key: 'ratio', label: 'Ratio', category: 'kalkulasi', isNumeric: true },
    { key: 'avg_weightbase', label: 'Avg Weight Base', category: 'kalkulasi', isNumeric: true },
    { key: 'avg_weightbase_emp', label: 'Avg Weight Base Emp', category: 'kalkulasi', isNumeric: true },
    { key: 'overbase_emp', label: 'Overbase Emp', category: 'kalkulasi', isNumeric: true },
    { key: 'overbase', label: 'Overbase', category: 'kalkulasi', isNumeric: true },
    { key: 'base', label: 'Base', category: 'kalkulasi', isNumeric: true },
    { key: 'base_emp', label: 'Base Emp', category: 'kalkulasi', isNumeric: true },
    { key: 'hk', label: 'HK', category: 'kalkulasi', isNumeric: true },
    { key: 'hk_emp', label: 'HK Emp', category: 'kalkulasi', isNumeric: true },
    { key: 'is_holiday', label: 'Hari Libur', category: 'kalkulasi' },
    { key: 'premi_rate', label: 'Premi Rate', category: 'premi', isNumeric: true },
    { key: 'overbase_premi', label: 'Overbase Premi', category: 'premi', isNumeric: true },
    { key: 'doublebase_premi_rate', label: 'Doublebase Premi Rate', category: 'premi', isNumeric: true },
    { key: 'doublebase_premi', label: 'Doublebase Premi', category: 'premi', isNumeric: true },
    { key: 'loose_fruit_qty', label: 'Loose Fruit Quantity', category: 'timbangan', isNumeric: true },
    { key: 'loose_fruit_rate', label: 'Loose Fruit Rate', category: 'premi', isNumeric: true },
    { key: 'loose_fruit_premi', label: 'Loose Fruit Premi', category: 'premi', isNumeric: true },
    { key: 'total_premi', label: 'Total Premi', category: 'premi', isNumeric: true },
];

export const DEFAULT_COLUMN_KEYS: string[] = [
    'company',
    'estate',
    'wb_ticket_no',
    'wb_weight',
    'spb_date',
    'date_posting',
    'division',
    'block',
    'bunch_qty',
    'ref_bjr',
    'ref_weight',
    'real_weight',
    'spb_nbr',
    'harvest_nbr',
    'harvest_date',
    'tph',
    'real_bjr',
    'loose_fruit_qty',
];
